import { render, staticRenderFns } from "./YWK_MigBoardContainer.vue?vue&type=template&id=2f1ac292"
import script from "./YWK_MigBoardContainer.ts?vue&type=script&lang=ts&external"
export * from "./YWK_MigBoardContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports